module.exports = __webpack_public_path__ + "img/validation-doc.eceba0f3.svg";